import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, FC } from 'react';

interface Props {
  className?: string;
  disabled?: boolean;
  id?: string;
  loading?: boolean;
  name?: string;
  onClick?: () => void;
  style?: CSSProperties;
  tabIndex?: number;
  title?: string;
  ariaLabel?: string;
}

const Pressable: FC<Props> = ({
  children,
  className,
  disabled,
  id,
  loading,
  name,
  onClick,
  style,
  tabIndex,
  title,
  ariaLabel,
}) => {
  return (
    <button
      className={className}
      name={name}
      disabled={disabled}
      id={id}
      onClick={onClick}
      style={style}
      tabIndex={tabIndex}
      title={title}
      type="button"
      aria-label={ariaLabel}
    >
      {
        loading ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : children
      }
    </button>
  );
};

export default Pressable;
